import Api from "@/services/Index";

const admin = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/admin/index", config);
};
const adminDelete = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("minor/applications/admin/delete/" + id);
};

const getAll = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications");
};

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/" + id);
};

const programs = async (facultyCode) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/programs/" + facultyCode);
};

const programsAdmin = async (facultyCode, studentProgramId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/programs/" + facultyCode + "/" + studentProgramId);
};

const store = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/applications");
};

const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete("/minor/applications/" + id);
};

const downloadAsExcel = (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/excel-export", {
        ...config,
        responseType: "arraybuffer",
    });
};

const checkDate = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/check-date");
};

const studentForm = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/student-form");
};

const makeApplication = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/applications/make-application");
};

const showApplication = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/show-application");
};

const minorApplicationsPrograms = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/programs/" + id);
};

const makePreference = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/application/preferences", data);
};

const getPreferences = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/application/preferences", config);
};

const deletePreferences = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete("/minor/application/preferences/" + id);
};

const savePreference = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/application/preferences/save");
};

const changeRank = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/application/preferences/change-rank", data);
};

const studentAffairsIndex = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/student-affairs-index", config);
};

const studentAffairsChangePreferencesRank = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/applications/student-affairs-change-preferences-rank", config);
};

const minorApplicationGetId = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/application/show/" + id);
};

const studentAffairsDecline = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/applications/student-affairs-decline", data);
};

const studentAffairsUpdateApplicationStatus = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(
        "/minor/applications/student-affairs-update-application-status",
        data
    );
};

const studentAffairsApprovePreference = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(
        "/minor/applications/student-affairs-approve-preference",
        data
    );
};

const studentAffairsApproveApplication = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(
        "/minor/applications/student-affairs-approve-application",
        data
    );
};

const prepSchoolIndex = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/prep-school-index", data);
};

const prepSchoolApprove = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/applications/prep-school-approve", data);
};

const academicUnitOfficeIndex = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/academic-unit-office-index", data);
};

const academicUnitOfficeApprove = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/applications/academic-unit-office-approve", data);
};

const studentAffairsAddPreference = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/applications/student-affairs-add-preference", data);
};

const studentAffairsDeletePreference = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/applications/student-affairs-delete-preference", data);
};

const prepSchoolBulkMessage = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/applications/prep-school-bulk-message", data);
};

const studentAffairsUpdateSemesterCount = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/applications/student-affairs-update-semester-count", data);
};

const studentAffairsSendMessage = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/minor/applications/student-affairs-send-message", data);
};

const studentAffairsRestorePreference = async (preferenceId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/student-affairs-restore-preference/" + preferenceId);
};

const excelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/excel-export/", { ...config, responseType: "arraybuffer" });
};

const yokReport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/yok-report", {...config, responseType: "arraybuffer" });
};

const onlineRegistration = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/minor/applications/online-registration/" + id);
};

export default {
    admin,
    adminDelete,
    studentForm,
    getAll,
    get,
    programs,
    store,
    del,
    downloadAsExcel,
    checkDate,
    makeApplication,
    showApplication,
    minorApplicationsPrograms,
    makePreference,
    getPreferences,
    deletePreferences,
    savePreference,
    changeRank,
    studentAffairsIndex,
    studentAffairsDecline,
    studentAffairsUpdateApplicationStatus,
    studentAffairsApprovePreference,
    studentAffairsApproveApplication,
    prepSchoolIndex,
    prepSchoolApprove,
    academicUnitOfficeIndex,
    academicUnitOfficeApprove,
    minorApplicationGetId,
    programsAdmin,
    studentAffairsAddPreference,
    studentAffairsDeletePreference,
    prepSchoolBulkMessage,
    studentAffairsUpdateSemesterCount,
    studentAffairsChangePreferencesRank,
    studentAffairsSendMessage,
    studentAffairsRestorePreference,
    excelExport,
    yokReport,
    onlineRegistration
};
